import { Box, MediaBox, MediaFlex, Shimmer } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

import Badge from "areas/product/jewlr/wizard-header/badge"

import WizardPricingLoading from "./wizard-pricing-loading"

const WizardHeaderLoading = ({ pdpHeaderPricingExp }) => (
  <>
    {pdpHeaderPricingExp > 0 ? (
      <MediaBox greaterThanOrEqual="tablet">
        <Badge />
        <Shimmer height="28px" mb={1} width="320px" />
        <WizardPricingLoading />
      </MediaBox>
    ) : (
      <MediaFlex
        greaterThanOrEqual="tablet"
        justifyContent="space-between"
        mb="10px"
      >
        <Box>
          <Shimmer height="25px" mb="2px" width="180px" />
          <Shimmer height="25px" width="180px" />
        </Box>
        <Box>
          <WizardPricingLoading />
        </Box>
      </MediaFlex>
    )}
    <MediaFlex
      alignItems="center"
      flexDirection="column"
      lessThan="tablet"
      mb="10px"
    >
      <Shimmer
        height="16px"
        mb={pdpHeaderPricingExp > 0 ? "10px" : "22px"}
        width="160px"
      />
      <Shimmer height="28px" mb={1} mt="6px" width="260px" />
    </MediaFlex>
  </>
)

WizardHeaderLoading.propTypes = {
  pdpHeaderPricingExp: PropTypes.number,
}

const mapStateToProps = (state) => {
  return {
    pdpHeaderPricingExp: state.experiment.pdpHeaderPricing.variant_id,
  }
}

export default connect(mapStateToProps)(WizardHeaderLoading)
